<template>
    <div>
        <div class="diagram__trapezoid diagram__trapezoid--lg">
            <ShapeTrapezoid/>
        </div>
        <div class="diagram__trapezoid diagram__trapezoid--md pl-lg-3 pr-lg-3 pl-0 pr-0 pb-2">
            <ShapeTrapezoid/>
        </div>
        <div class="diagram__trapezoid diagram__trapezoid--sm pl-lg-4 pr-lg-4 pl-0 pr-0 pb-2">
            <ShapeTrapezoid/>
        </div>
    </div>
</template>

<script>
import ShapeTrapezoid from './ShapeTrapezoid';

export default {
  components: {
    ShapeTrapezoid,
  },
};
</script>
